import { defineMessages } from 'react-intl'

export default defineMessages({
  errorMessage: {
    id: 'checkboxGroup.errorMessage',
    defaultMessage: 'Please select at least one option to continue',
  },
})
